import { render, staticRenderFns } from "./RegistrationStepOne.vue?vue&type=template&id=86fc8772&scoped=true&"
import script from "./RegistrationStepOne.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepOne.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStepOne.vue?vue&type=style&index=0&id=86fc8772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fc8772",
  null
  
)

export default component.exports